/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Tab_HistoryInputs */

const en_hub_tab_history = /** @type {(inputs: Hub_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const pl_hub_tab_history = /** @type {(inputs: Hub_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {Hub_Tab_HistoryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hub_tab_history = /** @type {((inputs?: Hub_Tab_HistoryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Tab_HistoryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hub_tab_history(inputs)
	return en_hub_tab_history(inputs)
});